export const ALL = "applicationTab";
export const RESOURCE_APPLICATION_TAB = "applicationTab";
export const RESOURCE_MODULE_TAB = "moduleTab";
export const RESOURCE_ENVIRONMENT_TAB = "environmentTab";
export const RESOURCE_SKILL_STREAM_TAB = "skillStreamTab";
export const RESOURCE_SKILL_SCHOOL_TAB = "skillSchoolTab";

export const VALIDITY_TAB = "validityTab";
export const PLAN_DETAIL_TAB = "planDetailTab";
export const INVOICE_TAB = "invoice";

export const ARR = "arr";
export const MRR = "mrr";
export const ARPC = "arpc";
export const REVENUE = "REVENUE";
export const CLIENT = "CLIENT";
export const GEOGRAPHIC = "GEOGRAPHIC";
export const USER = "USER";
export const SUBSCRIPTION = "SUBSCRIPTION";

export const MODULE_LIMIT = 25;
export const APPLICATION_LIMIT = 25;
export const INVOICE_LIMIT = 25;
export const CHANNEL_GROUP_LIMIT = 25;
export const SUBSCRIPTION_LIMIT = 25;

export const MONTH_VALIDITY = "month";
export const YEAR_VALIDITY = "year";
export const CUSTOM_VALIDITY = "custom";

export const PAID_PACK = "paid";
export const TRIAL_PACK = "trial";

export const SIMULANIS_INDIA = "SIMULANIS_INDIA";
export const SIMULANIS_UK = "SIMULANIS_UK";


export const TABS_TYPE_KEY = {
  [ALL]: "ALL",
  [RESOURCE_APPLICATION_TAB]: "APPLICATION",
  [RESOURCE_MODULE_TAB]: "MODULE",
  [RESOURCE_ENVIRONMENT_TAB]: "ENVIRONMENT",
  [RESOURCE_SKILL_STREAM_TAB]: "SKILL",
  [RESOURCE_SKILL_SCHOOL_TAB]: "SKILLSCHOOL",
};

export const CONVERSION_RATE_TYPE = "trial";

export const SLIDER_MAX_VALUE = 100;
